import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { Course } from 'src/app/models/course';
import { ActivatedRoute } from '@angular/router';
import { Quiz } from 'src/app/models/quiz';
import { QuizQuestionAnswer } from 'src/app/models/quizQuestionAnswer';
import { QuizService } from 'src/app/services/quiz.service';
import { QuizQuestion } from 'src/app/models/quizQuestion';

@Component({
  selector: 'app-practice-conent-quiz',
  templateUrl: './practice-conent-quiz.component.html',
  styleUrls: ['./practice-conent-quiz.component.scss']
})
export class PracticeConentQuizComponent implements OnInit {
  public loadedCourse:boolean = false;
  public course: Course;
  public courseId;
  public quiz: Quiz;
  public quizId;
  public quizLoaded:boolean=false;

  constructor(
    private _quiz: QuizService,
    private _course: CourseService,
    private _route: ActivatedRoute
  ) {
    this.quizId=this._route.snapshot.paramMap.get("quizId");
    this.courseId = this._route.snapshot.paramMap.get("id");
  }

  public addQuestion(){
    this._quiz.addQuestion(this.quiz.id).subscribe(
      (res:QuizQuestion) => {
        this.quiz.questions.push(new QuizQuestion(res));
      }
    );
  }

  public deleteQuestion(
    questionId:number,
    questionIndex:number
  ){
    if(!confirm('Confirm you want to delete this question.')) return;
    this._quiz.deleteQuestion(questionId).subscribe(
      res => {
        this.quiz.questions.splice(questionIndex, 1);
        //this._notify.showMessage('Question deleted.', 'OK');
      }
    );
  }

  public addAnswer(
    questionId:number,
    questionIndex:number
  ) {
    this._quiz.addAnswer(this.quiz.id, questionId).subscribe(
      res => {
        this.quiz.questions[questionIndex].answers.push(new QuizQuestionAnswer(res));
      }
    );
  }

  public deleteAnswer(
    questionIndex:number,
    answerIndex:number,
    answerId:number
  ) {
    this._quiz.deleteAnswer(answerId).subscribe(res => {
      this.quiz.questions[questionIndex].answers.splice(answerIndex,1);
    });
  }

  public saveQuiz(){
    if(!confirm('Confirm save changes?')) return;
    this._quiz.saveQuiz(this.quiz).subscribe(res => {
      // this._notify.showMessage('Quiz updated', 'OK');
    });
  }

  ngOnInit() {
    this._course.getCourse(this.courseId).subscribe(course=>{
      this.course=course;
      this.loadedCourse = true;
    });
    this._course.getQuiz(this.quizId).subscribe(
      res => {
        this.quiz=res;
        this.quizLoaded=true;
      }
    );
  }

}
